import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import AuthNavigator from './AuthNavigator';
import MainNavigator from './MainNavigator';
import QRNavigator from './QRNavigator';

const Stack = createStackNavigator();

export default function AppNavigator(props) {
    return (
        <Stack.Navigator
            headerMode={'none'}
            initialRouteName={props.token ? 'Main' : 'Auth'}
        >
            <Stack.Screen
                name={'Auth'}
                component={AuthNavigator}
                options={{
                    headerTransparent: true
                }}
            />
            <Stack.Screen
                name={'Main'}
                component={MainNavigator}
                options={{
                }}
            />
            <Stack.Screen
                name={'QR'}
                component={QRNavigator}
                options={{
                }}
            />
        </Stack.Navigator>
    )
}
